<template>
  <div>
    <app-header :is-show-info="false"></app-header>
    <div class="error-section-wrapper content-wrapper">
      <div class="error-content">
        <img src="../assets/images/error.svg" alt="error" />
        <h3>Oops, we have encountered an error</h3>
        <p>If you are the buyer, please restart the process</p>
        <p>
          <a class="link" :href="`mailto:${mailTo}`">{{ mailTo }}</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import { mapState } from 'vuex'
import Constants from '@/constants'
import { blockBackNavigationMixin } from '@/mixins/blockBackNavigationMixin'

export default {
  name: 'InternalError',
  components: { 'app-header': Header },
  mixins: [blockBackNavigationMixin],
  computed: {
    ...mapState('appSettings', ['error']),
    mailTo() {
      return Constants.mailto
    },
  },
}
</script>

<style scoped lang="scss">
.error-section-wrapper {
  padding: 40px 64px;
  display: flex;
  justify-content: center;

  @media screen and (max-width: $mobile-resolution) {
    padding: 32px 16px;
  }
}
.error-content {
  box-shadow: 0px 5px 15px rgba(166, 166, 166, 0.3);
  border-radius: 8px;
  padding: 24px 60px;
  text-align: center;
  width: 100%;

  @media screen and (max-width: $mobile-resolution) {
    padding: 24px;
  }

  & h3 {
    margin-top: 38px;
    font-size: 16px;

    @media screen and (max-width: $mobile-resolution) {
      font-size: 18px;
    }
  }

  & p {
    padding: 0px 55px;
    font-size: 14px;

    @media screen and (max-width: $mobile-resolution) {
      font-size: 16px;
    }
  }
}
</style>
